(function () {
    'use strict'

    app.controller('cancelUpdateCCController', ['$scope', '$location', '$cookies', function ($scope, $location, $cookies) {
        if ($cookies.get('TokenInfo') == undefined || $cookies.get('updatecc') == undefined) {
            $cookies.remove('updatecc', { path: '/' });
            $location.path('/login');
            return;
        }



    }]);

})();